import { FloatingComposeEditor } from 'composer-ui/compose/public/components';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { emailThreadCreated } from '../../email/actions/emailThreadCreated';
import { sendEmailCompositionFailed } from '../../email/actions/sendEmailCompositionFailed';
import ConnectedAsyncFileManager from '../../file-manager/components/ConnectedAsyncFileManager';
import { getIsUngatedForWhatsAppComposeInbox } from '../../selectors/gateSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const renderExistingFileSelect = props => /*#__PURE__*/_jsx(ConnectedAsyncFileManager, Object.assign({}, props));
renderExistingFileSelect.displayName = 'renderExistingFileSelect';
const FloatingEditor = () => {
  const dispatch = useDispatch();
  const inboxId = useSelector(getCurrentInboxId);
  const handleSend = useCallback(sendResponse => {
    sendResponse.then(({
      threadId
    }) => {
      dispatch(emailThreadCreated({
        threadId
      }));
    }).catch(error => {
      dispatch(sendEmailCompositionFailed(error));
    });
  }, [dispatch]);
  const isUngatedForWhatsAppCompose = useSelector(getIsUngatedForWhatsAppComposeInbox);
  return /*#__PURE__*/_jsx(FloatingComposeEditor, {
    inboxId: inboxId,
    onSend: handleSend,
    renderExistingFileSelect: renderExistingFileSelect,
    useWhatsAppCompose: isUngatedForWhatsAppCompose
  });
};
FloatingEditor.displayName = 'FloatingEditor';
export default FloatingEditor;